import { colors, createTheme, lighten } from '@mui/material';

export const COLOR_PRIMARY = '#DF1C71';
export const COLOR_SECONDARY = '#FFBFD9';

document.documentElement.style.setProperty('--primary-color', COLOR_PRIMARY);

export const theme = createTheme({
  typography: {
    fontFamily: 'Roboto, Arial',
  },
  palette: {
    primary: {
      main: COLOR_PRIMARY,
    },
    secondary: {
      main: COLOR_SECONDARY,
    },
  },
  components: {
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          lineHeight: 1.25,
          marginTop: 0,
        },
      },
    },
    MuiButtonGroup: {
      styleOverrides: {
        firstButton: { color: '#757575', borderColor: '#CFCFCF' },
        middleButton: { color: '#757575', borderColor: '#CFCFCF' },
        lastButton: { color: '#757575', borderColor: '#CFCFCF' },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 50,
        },
        sizeMedium: {
          height: 48,
          minWidth: 164,
          fontSize: 18,
          '&.Mui-disabled': {
            color: 'white',
            borderColor: '#CFCFCF',
            backgroundColor: '#CFCFCF',
          }
        },
        text: {
          fontWeight: '500 !important',
        },
        contained: {
          fontWeight: 700,
        },
        sizeSmall: {
          height: 37,
          fontSize: 14,
          fontWeight: 300,
          paddingLeft: 16,
          paddingRight: 16.
        },
        outlinedInherit: {
          borderColor: colors.grey[300],
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        shrink: {
          marginLeft: '0 !important',
        },
        outlined: {
          marginLeft: 8,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          paddingLeft: 24,
        },
        root: {
          borderRadius: 6,
        },
      },
    },
  },
});
